import React, { useEffect, useState } from 'react'
import AdminBreadcrumb from '../Common/AdminBreadcrumb';
import Editor from '../Common/Editor';

import { EditDynamicText, CreateDynamicText as CreateDynamicTextAPI } from '../../../API/admin'
import { useNavigate, useLocation } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import {
    CCard,
    CCardBody,
    CTable,
    CTableDataCell,
    CTableHeaderCell,
    CTableBody,
    CTableHead,
    CTableRow,

} from '@coreui/react';
import { Form } from 'react-bootstrap';

const CreateDynamicText = () => {
    // Manage AdminBreadcrumb
    const adminBreadcrumbLinks = [
        { label: 'Dashboard', to: '/admin/dashboard', active: false },
        { label: 'DynamicText', to: '/dynamic_text', active: false },
        { label: 'Edit', to: '', active: true }
    ];

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const [Type, setType] = useState(null);
    const [DisableRegister, setDisableRegister] = useState(false);
    const [errors, setErrors] = useState({});
    const [CriteriaShow, setCriteriaShow] = useState(false);
    const [FormData, setFormData] = useState({
        name: '',
        title: '',
        value: '',
        description: '',
        body: ''
    })

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        var type = urlParams.get('type')
        setType(type)
        var urlid = {
            data: urlParams.get('id')
        }
        let callAPI = async () => {
            let res = await EditDynamicText(urlid);
            if (res.status) {
                setFormData(res.data);
            }
        }
        if (urlid) {
            callAPI();
        }
    }, [])

    const HandelChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
    const handleEditorChange = (content) => {
        setFormData(prevState => ({
            ...prevState,
            value: content
        }));
    };
    const HandelSubmit = async (event) => {
        event.preventDefault();

        let res = await CreateDynamicTextAPI(FormData)
        if (res.data.status) {
            enqueueSnackbar('DynamicText saved successfully', {
                variant: 'success', action: (key) => (
                    <button className='toast_close_btn'
                        onClick={() => {
                            // Close the Snackbar
                            closeSnackbar(key);
                        }}
                    >
                        X
                    </button>
                ),
            });
            navigate('/dynamic_text');
        }
        else {
            // swal("Oops!", res.data.message, "error");
            enqueueSnackbar('Unable to save DynamicText', {
                variant: 'error', action: (key) => (
                    <button className='toast_close_btn'
                        onClick={() => {
                            // Close the Snackbar
                            closeSnackbar(key);
                        }}
                    >
                        X
                    </button>
                ),
            });
            // swal("Oops!", res.data.message, "error");
        }

    }
    const handleCopyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            console.log('Text copied to clipboard:', text);
            enqueueSnackbar('Text copied to clipboard ', {
                variant: 'success', action: (key) => (
                    <button className='toast_close_btn'
                        onClick={() => {
                            // Close the Snackbar
                            closeSnackbar(key);
                        }}
                    >
                        X
                    </button>
                ),
            })
        }).catch(err => {
            console.error('Failed to copy text: ', err);
        });
    };




    return (
        <>
            <h4 className="card-title mb-3 align-items-center">
                Create a DynamicText
            </h4>
            <AdminBreadcrumb links={adminBreadcrumbLinks} />

            <CCard className="mb-4">
                <CCardBody>
                    <div className="row justify-content-center">
                        <div className="col-md-7">
                            <CTable bordered borderColor='rgb(50 58 73)'>
                                <CTableHead>
                                    <CTableRow>
                                        <CTableHeaderCell scope="col">Key</CTableHeaderCell>
                                        <CTableHeaderCell scope="col">Value</CTableHeaderCell>
                                    </CTableRow>
                                </CTableHead>
                                <CTableBody>
                                    <CTableRow>
                                        <CTableHeaderCell scope="col">User Name</CTableHeaderCell>
                                        <CTableHeaderCell scope="col" onClick={() => handleCopyToClipboard('{{user.name}}')}>{'{{user.name}}'}</CTableHeaderCell>
                                    </CTableRow>
                                    {
                                        FormData.name == 'Joined_waitlist' ||  FormData.name == 'withdrawal_notification' ||                                                 FormData.name == 'slots_available' || FormData.name == 'reset_slots_available' ? (
                                            <>
                                            <CTableRow>
                                                <CTableHeaderCell scope="col">Team Name</CTableHeaderCell>
                                                <CTableHeaderCell scope="col" onClick={() => handleCopyToClipboard('{{team.name}}')}>{'{{team.name}}'}</CTableHeaderCell>
                                            </CTableRow>
                                            <CTableRow>
                                                <CTableHeaderCell scope="col">Sport</CTableHeaderCell>
                                                <CTableHeaderCell scope="col" onClick={() => handleCopyToClipboard('{{sport.value}}')}>{'{{sport.value}}'}</CTableHeaderCell>
                                            </CTableRow>
                                            {
                                                FormData.name == 'slots_available' || FormData.name == 'reset_slots_available' ? (
                                                    <>
                                                <CTableRow>
                                                <CTableHeaderCell scope="col">Slot Link</CTableHeaderCell>
                                                <CTableHeaderCell scope="col" onClick={() => handleCopyToClipboard('{{slot.link}}')}>{'{{slot.link}}'}</CTableHeaderCell>
                                            </CTableRow>
                                                    </>
                                                ): null
                                            }
                                            </>
                                        ) : FormData.name == 'registration_open' ?  <>
                                         <CTableRow>
                                                <CTableHeaderCell scope="col">Tournament Name</CTableHeaderCell>
                                                <CTableHeaderCell scope="col" onClick={() => handleCopyToClipboard('{{tournament.name}}')}>{'{{tournament.name}}'}</CTableHeaderCell>
                                            </CTableRow>

                                            <CTableRow>
                                                <CTableHeaderCell scope="col">Registration Link</CTableHeaderCell>
                                                <CTableHeaderCell scope="col" onClick={() => handleCopyToClipboard('{{registration.link}}')}>{'{{registration.link}}'}</CTableHeaderCell>
                                            </CTableRow>
                                        </>: null
                                    }
                                </CTableBody>
                            </CTable>
                            <ul>

                            </ul>
                            <form onSubmit={HandelSubmit}>
                                <div className='row mb-4' >
                                    <div className="col-12">
                                        <label htmlFor="exampleInputEmail1" className="form-label mb-0 mt-3">
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name='name'
                                            onChange={HandelChange}
                                            value={FormData.name}
                                            placeholder='Enter name'
                                            readOnly
                                        />

                                        <input type="hidden" value={FormData.id} name='id' />
                                    </div>
                                    <div className="col-12">

                                        <label htmlFor="exampleInputEmail1" className="form-label mb-0 mt-3">
                                            {Type == 'email' ? 'Subject' : 'title'}
                                        </label>
                                        <textarea
                                            onChange={HandelChange}
                                            value={FormData.title}
                                            className="form-control"
                                            name='title'
                                            placeholder={'Enter ' + Type}
                                            required
                                        >

                                        </textarea>


                                    </div>
                                    <div className="col-12">

                                        <label htmlFor="exampleInputEmail1" className="form-label mb-0 mt-3">
                                            {Type == 'email' ? 'Body' : 'value'}

                                        </label>
                                        {
                                            Type == 'email' ? (
                                                <Editor name='value' dataValue={FormData.value} onChange={(content) => handleEditorChange(content)}></Editor>
                                            ) : (
                                                <textarea
                                                    onChange={HandelChange}
                                                    value={FormData.value}
                                                    className="form-control"
                                                    name='value'
                                                    placeholder={'Enter ' + Type}
                                                    required
                                                >

                                                </textarea>

                                            )
                                        }


                                    </div>

                                    <div className="col-12">

                                        <label htmlFor="exampleInputEmail1" className="form-label mb-0 mt-3">
                                            Description
                                        </label>
                                        <textarea
                                            onChange={HandelChange}
                                            value={FormData.description}
                                            className="form-control"
                                            name='description'
                                            placeholder='Enter description'
                                            required
                                        >

                                        </textarea>


                                    </div>
                                </div>
                                <button type="button" className="btn btn-secondary ms-3 float-end" onClick={() => window.history.back()}>
                                    Cancel
                                </button>
                                <button type="submit" className="btn btn-primary float-end" >
                                    Submit
                                </button>
                            </form>
                        </div>
                    </div>
                </CCardBody>
            </CCard>
        </>
    )
}
export default CreateDynamicText;